export default {
  init() {
      
    /* event title, event listing boxes - matchheight */
    if(jQuery(window).width() > 991){
        jQuery('.equal-height').matchHeight({
            byRow: true,
        });
        
        /* Header search icon click for > 991px */
        jQuery(".header-info .ajaxsearchpro.asp_main_container .probox").addClass('hide-search-box');
        jQuery('.header-info .promagnifier .innericon').click(function() {
            if(jQuery('body').hasClass('top-search-active')){
                jQuery('body').removeClass('top-search-active');
                jQuery('body').addClass('top-search-deactive');
                
                jQuery('.header-info .promagnifier .innericon').parents('.probox').removeClass('top-search-active');
                jQuery('.header-info .promagnifier .innericon').parents('.probox').addClass('top-search-deactive');
            }else{
                jQuery('body').removeClass('top-search-deactive');
                jQuery('body').addClass('top-search-active');
                
                jQuery('.header-info .promagnifier .innericon').parents('.probox').removeClass('top-search-deactive');
                jQuery('.header-info .promagnifier .innericon').parents('.probox').addClass('top-search-active');
            }
        });
        
        jQuery(document).click(function (e){
            var list_box = jQuery(".ajaxsearchpro.asp_an_fadeInDrop");
            if (!list_box.is(e.target) && list_box.has(e.target).length === 0){
                list_box.hide();
                
                jQuery('body').removeClass('top-search-active');
                jQuery('body').addClass('top-search-deactive');
                
                jQuery('.header-info .promagnifier .innericon').parents('.probox').removeClass('top-search-active');
                jQuery('.header-info .promagnifier .innericon').parents('.probox').addClass('top-search-deactive');
            }
            
            var form_box = jQuery(".ajaxsearchpro.asp_main_container");
            if (!form_box.is(e.target) && form_box.has(e.target).length === 0){
                e.stopPropagation();
            }
        });
    }else{
        jQuery('.equal-height').matchHeight({
            remove: true,
        });
        if(jQuery(window).width() > 575){
            if(jQuery('.agenda-box').not( '.two-col' ).length){
                jQuery('.equal-height.info').matchHeight({
                    byRow: true,
                });
            }
        }
    }
    
    /* mobile menu hamburger visibilty for all pages */
    if(jQuery(window).width() < 768){
        jQuery(window).scroll(function () {
            var scrollVal = jQuery(window).scrollTop();
            if(scrollVal > 50){
                jQuery('.mob-menu-header-holder').addClass('zIndex');
            }else{
                jQuery('.mob-menu-header-holder').removeClass('zIndex');
            }
        });
        jQuery('.agenda-box.two-col .equal-height').matchHeight({
            remove: true,
        });
    }else{
        jQuery('.agenda-box.two-col .equal-height').matchHeight({
            byRow: true,
        });
    }
    
    /* Gallery */
    jQuery(document).on('click', '[data-toggle="lightbox"]', function (event) {
        event.preventDefault();
        jQuery(this).ekkoLightbox();
    });
    
    /* accordian bootstrap - open first by default */
    if(jQuery('#saxon-accordion-left').length){
        jQuery('#saxon-accordion-left').find('.accordion-box:first .collapse').addClass('show');
    }
    
    /* Resize */
    jQuery(window).resize(function () {
        if(jQuery(window).width() < 768){
            jQuery(window).scroll(function () {
                var scrollVal = jQuery(window).scrollTop();
                if(scrollVal > 50){
                    jQuery('.mob-menu-header-holder').addClass('zIndex');
                }else{
                    jQuery('.mob-menu-header-holder').removeClass('zIndex');
                }
            });
        }
    });
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js